import { getRequest, postRequest, putRequest, deleteRequest } from './api';

const chatsApi = {
  async getChatSessions({ page = 1, per_page = 10 } = {}) {
    return getRequest('/api/chat/sessions', {}, { page, per_page });
  },

  async createChatSession(payload) {
    return postRequest('/api/chat/sessions', payload);
  },

  async getChatSession(sessionId) {
    return getRequest(`/api/chat/sessions/${sessionId}`);
  },

  async postCampaignConversationMessage(sessionId, payload) {
    return postRequest(`/api/chat/sessions/${sessionId}/campaign-conversation-message`, payload);
  },

  async archiveChatSession(sessionId) {
    return deleteRequest(`/api/chat/sessions/${sessionId}`);
  },

  async updateChatSession(sessionId, payload) {
    return putRequest(`/api/chat/sessions/${sessionId}`, payload);
  },

  async sendCampaign(sessionId) {
    return postRequest(`/api/chat/sessions/${sessionId}/send-campaign`, {});
  },

  async getCampaign(sessionId) {
    return getRequest(`/api/chat/sessions/${sessionId}/campaign`);
  },

  async editCampaign(sessionId, payload) {
    return putRequest(`/api/chat/sessions/${sessionId}/campaign`, payload);
  },

  async generateAnalyticsSummary(screenshotData) {
    return postRequest('/api/chat/generate-analytics-summary', screenshotData);
  },

  async sendAnalyticsReport(pdfData, reportData) {
    return postRequest('/api/chat/send-analytics-report', { pdfData, reportData });
  },
};

export default chatsApi;